// Georgian (default). Keys are shared by en.ts / ru.ts (typed via Dict).
const ka = {
  meta: {
    title: "HOTGAME — გავახუროთ!",
    description: "ქართული წვეულების თამაშები ტელეფონით: ბლეფმანია, ჯაშუში, Match Party, მართალია თუ ტყუილი და ჯოკერის რვეული.",
  },
  nav: {
    games: "თამაშები",
    join: "კოდით შესვლა",
    joker: "ჯოკერის რვეული",
    login: "შესვლა",
    account: "პროფილი",
    brand: "ბრენდბუქი",
    admin: "ადმინი",
    home: "მთავარი",
    menu: "მენიუ",
  },
  common: {
    play: "თამაში",
    back: "უკან",
    next: "შემდეგი",
    close: "დახურვა",
    cancel: "გაუქმება",
    save: "შენახვა",
    confirm: "დადასტურება",
    yes: "კი",
    no: "არა",
    loading: "იტვირთება…",
    retry: "თავიდან ცდა",
    copy: "კოპირება",
    copied: "დაკოპირდა!",
    share: "გაზიარება",
    players: "მოთამაშე",
    playersN: "{n} მოთამაშე",
    minutes: "{n} წთ",
    you: "შენ",
    host: "ჰოსტი",
    bot: "ბოტი",
    audience: "მაყურებელი",
    points: "ქულა",
    pts: "{n} ქ.",
    sound: "ხმა",
    mute: "ხმის გამორთვა",
    unmute: "ხმის ჩართვა",
    on: "ჩართ.",
    off: "გამორთ.",
    or: "ან",
    seconds: "{n} წმ",
    round: "რაუნდი {n}",
    of: "{a} / {b}",
    lang: { ka: "ქართული", en: "English", ru: "Русский" },
    langShort: { ka: "ქარ", en: "ENG", ru: "РУС" },
  },
  home: {
    heroTitle: "გავახუროთ!",
    // Width of heroTitle in em at weight 900 (measured), so the headline can fill the row exactly.
    heroEm: 6.7,
    heroSub: "ექვსი თამაში მეგობრებთან ერთად. ტელეფონი ხელში — და წავედით.",
    create: "ოთახის შექმნა",
    joinPlaceholder: "კოდი",
    joinGo: "შესვლა",
    gamesTitle: "აირჩიე თამაში",
    gamesSub: "ყველა თამაში მუშაობს ქართულად, ინგლისურად და რუსულად — კითხვებიც შესაბამის ენაზე მოვა.",
    howTitle: "როგორ ვთამაშობთ",
    how1: "ერთი ქმნის ოთახს — ტელეფონით, ლეპტოპით ან ტელევიზორზე.",
    how2: "დანარჩენები შემოდიან QR-ით ან 4-ასოიანი კოდით. აპლიკაცია არ სჭირდება.",
    how3: "თამაშობთ, იცინით და კამათობთ. ქულებს ჩვენ ვითვლით.",
    tryTitle: "სცადე ახლავე",
    tryQ: "1932 წელს ავსტრალიის არმიამ ნამდვილი ომი წამოიწყო — და წააგო — ____ წინააღმდეგ.",
    tryA: "ემუების",
    tryLies: ["კენგურუების", "კურდღლების", "კოალების"],
    tryNote: "ეს „ემუების დიდი ომი“ იყო: ტყვიამფრქვევებით შეიარაღებული ჯარისკაცები 20 000 ემუს ვერ მოერივნენ.",
    trySub: "ერთ-ერთი პასუხი სიმართლეა. დანარჩენი — ტყუილი. რომელია?",
    tryRight: "სწორია! ეს მართლა ასეა 🔥",
    tryWrong: "მოგატყუეს! სიმართლე იყო:",
    tryAgain: "კიდევ ერთი",
    adultTitle: "18+ რეჟიმი",
    adultSub: "როცა ბავშვებს დაეძინათ. ცხარე კითხვები შეყვარებულებზე, წვეულებებზე და იმაზე, რაზეც ხმამაღლა არ ლაპარაკობენ. ჩაირთვება მხოლოდ ჰოსტის დადასტურებით.",
    statQuestions: "კითხვა",
    statGames: "თამაში",
    statLangs: "ენა",
    footerTag: "ცხელი თამაშები ცივი საღამოებისთვის.",
    rights: "© 2026 HOTGAME",
  },
  games: {
    bluff: {
      name: "ბლეფმანია",
      tagline: "მოატყუე. გამოიცანი. გაიმარჯვე.",
      short: "მოიფიქრე დამაჯერებელი ტყუილი, მოატყუე მეგობრები და თავად იპოვე სიმართლე.",
      players: "2–12",
      time: "15–25",
      rules: [
        "ეკრანზე ჩნდება უცნაური, მაგრამ ნამდვილი ფაქტი გამოტოვებული სიტყვით.",
        "ყველა წერს თავის ტყუილს — ისეთს, რომ სხვებმა სიმართლე ეგონოთ.",
        "ხმის მიცემისას ეძებ ნამდვილ პასუხს: სიმართლე +1000, ყოველი მოტყუებული მეგობარი +500.",
        "მეორე რაუნდში ქულები ორმაგდება, ცხელ ფინალში — სამმაგდება.",
      ],
    },
    spy: {
      name: "ჯაშუში",
      tagline: "ერთ-ერთი თქვენგანი ტყუის.",
      short: "ყველამ იცის საიდუმლო სიტყვა, ჯაშუშის გარდა. 3–5 კითხვა — და ვინ არის ჯაშუში?",
      players: "3–16",
      time: "5–10",
      rules: [
        "ყველა იღებს საიდუმლო სიტყვას. ჯაშუში (ან რამდენიმე ჯაშუში) — მხოლოდ თემას.",
        "აპლიკაცია სვამს 3–5 კითხვას. რიგრიგობით პასუხობთ — ზედმეტი არ გასცე, მაგრამ ჯაშუშსაც ნუ დაემსგავსები.",
        "კითხვების ბოლოს ყველა ხმას აძლევს, ვინ ჰგონია ჯაშუში.",
        "დაჭერილ ჯაშუშს ბოლო შანსი აქვს: თუ სიტყვას გამოიცნობს, მაინც იგებს.",
      ],
    },
    match: {
      name: "Match Party",
      tagline: "ხინკალი ხინკალს ეძებს.",
      short: "მეხსიერების თამაში ქართული სუფრის ბარათებით. იპოვე წყვილები, ააწყე კომბო და ერიდე ბომბებს.",
      players: "1–6",
      time: "5–10",
      rules: [
        "თითო სვლაზე აბრუნებ ორ ბარათს. თუ ერთნაირია — წყვილი შენია და ისევ შენ თამაშობ.",
        "ზედიზედ წყვილები კომბოს გაძლევს: +100, +150, +200…",
        "ბომბი ქულებს გართმევს და სვლა გადადის მომდევნოზე.",
        "ითამაშეთ ერთ ტელეფონზე რიგრიგობით, ან ყველამ თავისი ტელეფონიდან.",
      ],
    },
    truf: {
      name: "მართალია თუ ტყუილი",
      tagline: "10 წამი. სიმართლე თუ ტყუილი?",
      short: "სწრაფი ვიქტორინა: ეკრანზე მტკიცებაა, შენ ირჩევ — მართალია თუ ტყუილი. რაც უფრო სწრაფად, მით მეტი ქულა.",
      players: "1–30",
      time: "5",
      rules: [
        "ჩნდება მტკიცება — ზოგი გაოცებს, ზოგი უბრალოდ ცნობილი მითია.",
        "აირჩიე: მართალია თუ ტყუილი. სწრაფი სწორი პასუხი მეტ ქულას იძლევა.",
        "სამი სწორი ზედიზედ — სერია იწყება და ბონუსი იზრდება 🔥",
      ],
    },
    guess: {
      name: "Guess — გამოიცანი",
      tagline: "დაინახე. თქვი. გადაეცი სვლა.",
      short: "სურათების სწრაფი დუელი ხმით: თქვი პასუხი ხმამაღლა, სისტემა თვითონ ამოწმებს. თითოეულს 60 წამი აქვს მთელ მატჩზე.",
      players: "2–6",
      time: "3–6",
      rules: [
        "თითოეულ მოთამაშეს აქვს 60 წამი. სწორი პასუხი გადასცემს სვლას. შეცდომა და გამოტოვება აკლებს 3 წამს.",
        "პასუხი თქვი ხმამაღლა — ქართულად ან ინგლისურად. ღილაკზე დაჭერა არ გჭირდება.",
        "თქვი „გამოტოვება“ ან “skip” — ახალი სურათი მოვა, მაგრამ 3 წამი დაგაკლდება.",
        "ვისაც დრო პირველს ამოეწურება, ის მარცხდება.",
      ],
    },
    joker: {
      name: "ჯოკერის რვეული",
      tagline: "ქულებს რვეული დათვლის.",
      short: "ქართული ჯოკერის ანგარიში: დააჭირე, ვინ რას იძახის და რამდენი წაიღო — დანარჩენს რვეული დაითვლის.",
      players: "3–4",
      time: "∞",
    },
  },
  cats: {
    weird: "WTF ფაქტები",
    animals: "ცხოველები",
    body: "ადამიანის სხეული",
    science: "მეცნიერება",
    space: "კოსმოსი",
    history: "ისტორია",
    laws: "უცნაური კანონები",
    money: "ბიზნესი და ფული",
    places: "ადგილები",
    geo: "გეოგრაფია",
    food: "საჭმელ-სასმელი",
    popculture: "პოპ-კულტურა",
    sport: "სპორტი",
    georgia: "საქართველო",
    myths: "მითები",
    tech: "ტექნოლოგია",
    night: "18+ ღამე",
  },
  create: {
    title: "ახალი ოთახი",
    online: "ყველა თავისი ტელეფონით",
    onlineSub: "ოთახის კოდი და QR — მეგობრები თავიანთ ტელეფონებიდან შემოდიან.",
    local: "ერთი ტელეფონით",
    localSub: "ტელეფონი გადაეცით ერთმანეთს — ინტერნეტი არ სჭირდება.",
    solo: "მარტო ბოტებთან",
    soloSub: "ივარჯიშე ბოტებთან, სანამ მეგობრები მოვლენ.",
    yourName: "შენი სახელი",
    namePh: "მაგ: ნინო",
    avatar: "შენი პერსონაჟი",
    roomLang: "კითხვების ენა",
    go: "ოთახის შექმნა",
    nameRequired: "ჯერ სახელი ჩაწერე",
    howToPlay: "როგორ ვთამაშობთ",
  },
  join: {
    title: "ოთახში შესვლა",
    code: "ოთახის კოდი",
    codePh: "ABCD",
    go: "შესვლა",
    asAudience: "მაყურებლად შესვლა",
    notFound: "ასეთი ოთახი ვერ ვიპოვეთ. შეამოწმე კოდი.",
    full: "ოთახი სავსეა — შეგიძლია მაყურებლად შეხვიდე.",
    started: "თამაში უკვე მიდის — შემდეგი რაუნდიდან ჩაერთვები.",
    gameIs: "თამაში: {game}",
  },
  lobby: {
    title: "ლობი",
    code: "ოთახის კოდი",
    scan: "დაასკანერე და შემოდი",
    invite: "მოიწვიე მეგობრები",
    copyLink: "ბმულის კოპირება",
    whatsapp: "WhatsApp",
    telegram: "Telegram",
    messenger: "Messenger",
    shareText: "შემოდი HOTGAME-ზე! ვთამაშობთ {game}-ს. კოდი: {code}",
    waitingHost: "ველოდებით, როდის დაიწყებს ჰოსტი…",
    start: "დაწყება",
    needPlayers: "საჭიროა მინიმუმ {n} მოთამაშე",
    addBot: "+ ბოტი",
    removeBot: "ბოტის წაშლა",
    kick: "გაგდება",
    makeHost: "ჰოსტად დანიშვნა",
    settings: "პარამეტრები",
    settingsHostOnly: "პარამეტრებს ჰოსტი ცვლის",
    rename: "სახელის შეცვლა",
    becomeAudience: "მაყურებლად გადასვლა",
    becomePlayer: "მოთამაშედ გადასვლა",
    leave: "ოთახიდან გასვლა",
    leaveConfirm: "ნამდვილად გადიხარ ოთახიდან?",
    lang: "კითხვების ენა: {lang}",
    adult: "18+ კითხვები",
    adultConfirmTitle: "18+ რეჟიმის ჩართვა",
    adultConfirmText: "18+ კითხვებში არის ხუმრობები სექსზე, ალკოჰოლზე და პაემნებზე. ჩართე მხოლოდ მაშინ, თუ ყველა მოთამაშე 18 წლის ან მეტისაა.",
    adultConfirmYes: "ყველა 18+ ვართ — ჩართე",
    players: "მოთამაშეები ({n})",
    audience: "მაყურებლები ({n})",
    offline: "კავშირი დაკარგა",
    tv: "ეკრანის რეჟიმი (TV)",
  },
  room: {
    connecting: "ოთახთან ვუკავშირდებით…",
    reconnecting: "კავშირი გაწყდა — ვცდილობთ ხელახლა…",
    gone: "ოთახი აღარ არსებობს ან ვადა გაუვიდა.",
    kicked: "ჰოსტმა ოთახიდან გაგაგდო.",
    toHome: "მთავარზე დაბრუნება",
    paused: "პაუზა",
    pausedSub: "ჰოსტმა თამაში შეაჩერა",
    pause: "პაუზა",
    resume: "გაგრძელება",
    skip: "გამოტოვება",
    playAgain: "კიდევ ერთხელ!",
    backToLobby: "ლობიში დაბრუნება",
    newRound: "შემდეგი რაუნდი",
    audienceNote: "შენ მაყურებელი ხარ — უყურე და გაიცინე 🍿",
    hostControls: "ჰოსტის მართვა",
    scoreboard: "ცხრილი",
    winner: "გამარჯვებული!",
    winners: "გამარჯვებულები!",
    report: "კითხვაში შეცდომაა?",
    reportThanks: "მადლობა! გადავხედავთ.",
    reportReasons: { wrong: "ფაქტი არასწორია", typo: "გრამატიკა / შეცდომა", boring: "მოსაწყენია", offensive: "შეურაცხმყოფელია", other: "სხვა" },
  },
  bluff: {
    act0: "რაუნდი 1",
    act1: "რაუნდი 2",
    act2: "ცხელი ფინალი",
    actSub0: "აბა, გავხურდეთ!",
    actSub1: "ქულები ორმაგდება ×2",
    actSub2: "ერთი კითხვა. ქულები ×3",
    question: "კითხვა {n}/{total}",
    writeTitle: "მოიფიქრე ტყუილი",
    writePh: "შენი ტყუილი…",
    send: "გაგზავნა",
    change: "შეცვლა",
    help: "მომიფიქრე ტყუილი",
    helpLeft: "დარჩა {n}",
    helpUse: "გამოიყენე",
    yourLie: "შენი ტყუილი",
    waitingOthers: "ველოდებით დანარჩენებს…",
    autoLie: "დრო ამოგეწურა — ტყუილი ჩვენ დავწერეთ შენ მაგივრად (ნახევარი ქულა).",
    voteTitle: "რომელია სიმართლე?",
    voteHint: "შენს ტყუილს ვერ აირჩევ. 😂 — თუ რომელიმე პასუხმა გაგაცინა.",
    yours: "შენი ტყუილი",
    reread: "წაიკითხე თავიდან",
    voted: "ხმა მიცემულია!",
    picked: "შენი არჩევანი",
    likes: "მოწონება",
    revealLie: "{name}-ის ტყუილი!",
    revealLies: "{names}-ის ტყუილი!",
    revealHouse: "ჩვენი ტყუილი!",
    revealAuto: "{name}-ის ტყუილი (ავტომატური)",
    revealTruth: "სიმართლე!",
    fooled: "წამოეგნენ:",
    found: "იპოვეს:",
    nobodyFound: "სიმართლე ვერავინ იპოვა 😱",
    everyoneFound: "ყველამ იპოვა სიმართლე!",
    onlyYou: "მხოლოდ შენ იპოვე! 🔥",
    gotYou: "{name}-მა მოგატყუა!",
    gotYouHouse: "ჩვენმა ტყუილმა გაგაცურა 😏",
    youFooled: "შენი ტყუილით {n} მოატყუე!",
    scoresTitle: "ცხრილი",
    finalTitle: "საბოლოო შედეგები",
    awards: {
      liar: "ტყუილების მეფე",
      detective: "დეტექტივი",
      gullible: "ყველაზე მიამიტი",
      liked: "ხალხის ფავორიტი",
      bestLie: "საუკეთესო ტყუილი",
    },
    awardsSub: {
      liar: "{n}-ჯერ მოატყუა სხვები",
      detective: "{n}-ჯერ იპოვა სიმართლე",
      gullible: "{n}-ჯერ წამოეგო",
      liked: "{n} მოწონება",
      bestLie: "„{text}“ — {n} მოტყუებული",
    },
    nextIn: "შემდეგი კითხვა…",
    skipWrite: "ხმის მიცემაზე გადასვლა",
    skipVote: "შედეგებზე გადასვლა",
    errors: {
      is_truth: "ეს სიმართლეა! 😅 სხვა ტყუილი მოიფიქრე.",
      too_close: "ძალიან ჰგავს სიმართლეს — სხვა რამე სცადე.",
      taken: "ზუსტად ეს უკვე ვიღაცამ დაწერა. სხვა სცადე!",
      own_option: "საკუთარ ტყუილს ვერ აირჩევ 😉",
      no_help_left: "დახმარება აღარ დაგრჩა.",
    },
  },
  spy: {
    rolesTitle: "საიდუმლო როლები",
    tapToSee: "შეეხე და ნახე შენი როლი",
    hideFromOthers: "დაფარე ეკრანი — სხვებმა არ დაინახონ!",
    youAreSpy: "შენ ხარ ჯაშუში!",
    spyHint: "სიტყვა არ იცი. მოუსმინე სხვებს და შეეცადე არ გამოჩნდე.",
    spyTheme: "თემა: {pack}",
    spyNoTheme: "თემაც კი არ იცი 😈",
    secretWord: "საიდუმლო სიტყვა",
    civHint: "ჯაშუშმა ეს სიტყვა არ იცის. ნუ გასცემ, მაგრამ ეჭვიც ნუ გაგიჩნდება!",
    spiesInGame: "ამ თამაშში {n} ჯაშუშია",
    seen: "დავინახე",
    seenCount: "როლი ნახა: {a}/{b}",
    startQuestions: "კითხვების დაწყება",
    qTitle: "კითხვა {n}/{total}",
    order: "პასუხობენ რიგრიგობით:",
    yourTurn: "შენი ჯერია! უპასუხე ხმამაღლა",
    turnOf: "პასუხობს: {name}",
    doneTurn: "ვუპასუხე ✓",
    nextQuestion: "შემდეგი კითხვა",
    answerPh: "შენი პასუხი (მოკლედ)…",
    answered: "უპასუხა: {a}/{b}",
    answersTitle: "პასუხები",
    toVote: "ხმის მიცემაზე გადასვლა",
    voteTitle: "ვინ არის ჯაშუში?",
    voteSub: "აირჩიე ერთი ეჭვმიტანილი.",
    votedFor: "შენ ხმა მიეცი: {name}",
    votesIn: "ხმა მისცა: {a}/{b}",
    closeVote: "ხმის მიცემის დასრულება",
    groupAccuse: "ჯგუფმა ვინ აირჩია?",
    accuse: "ბრალის წაყენება",
    revealTitle: "ჯაშუში იყო…",
    revealTitlePlural: "ჯაშუშები იყვნენ…",
    caught: "დაიჭირეს! 🎯",
    escaped: "გაიპარა! 🏃",
    wrongAccused: "{name} არ იყო ჯაშუში 😬",
    noOneAccused: "ხმები გაიყო — ვერავინ დაიჭირეთ!",
    guessTitle: "ბოლო შანსი!",
    guessSub: "გამოიცანი საიდუმლო სიტყვა — თუ გამოიცნობ, მაინც იგებ.",
    guessWait: "დაჭერილი ჯაშუში სიტყვას იხსენებს…",
    guessed: "{name}-მა გამოიცნო სიტყვა! 😱",
    guessedWrong: "{name}-მა ვერ გამოიცნო: „{word}“",
    civWin: "მოქალაქეებმა მოიგეს!",
    spyWin: "ჯაშუშებმა მოიგეს!",
    wordWas: "სიტყვა იყო: {word}",
    roundPts: "+{n}",
    passTo: "გადაეცი ტელეფონი: {name}",
    passReady: "მე ვარ {name} — მაჩვენე",
    passHide: "დავიმახსოვრე — დამალე",
    localSetup: "მოთამაშეები",
    addPlayer: "+ მოთამაშე",
    playerPh: "მოთამაშე {n}",
    packs: "თემები",
    allPacks: "ყველა თემა",
    spies: "ჯაშუშების რაოდენობა",
    spiesAuto: "ავტომატურად",
    questions: "კითხვები",
    mode: "პასუხები",
    modeVoice: "ხმამაღლა",
    modeText: "წერილობით",
    spyHintSetting: "ჯაშუშმა იცის თემა",
    qTime: "დრო კითხვაზე",
    qTimeNone: "ულიმიტო",
  },
  match: {
    turn: "{name}-ის სვლა",
    yourTurn: "შენი სვლაა!",
    match: "წყვილი! +{n}",
    combo: "კომბო ×{n}! +{p}",
    miss: "არ დაემთხვა",
    boom: "ბუმ! 💥 −{n}",
    timeout: "დრო ამოიწურა!",
    pairsLeft: "დარჩა {n} წყვილი",
    pairs: "წყვილები",
    theme: "ბარათები",
    bombs: "ბომბები",
    bombsNone: "არა",
    turnTime: "დრო სვლაზე",
    turnTimeNone: "ულიმიტო",
    size: "დაფის ზომა",
    themes: { supra: "ქართული სუფრა", animals: "ცხოველები", party: "წვეულება", tbilisi: "ემოჯი-მიქსი", emoji: "სახეები" },
    hotseat: "ერთ ტელეფონზე",
    addLocal: "+ მოთამაშე",
  },
  truf: {
    statement: "მტკიცება {n}/{total}",
    true: "მართალია",
    false: "ტყუილია",
    itsTrue: "მართალია! ✓",
    itsFalse: "ტყუილია! ✗",
    correct: "სწორია! +{n}",
    wrong: "არასწორია",
    noAnswer: "ვერ მოასწარი",
    streak: "{n} ზედიზედ 🔥",
    answered: "უპასუხა: {a}/{b}",
    count: "მტკიცებების რაოდენობა",
    time: "დრო პასუხზე",
    cats: "თემები",
    allCats: "ყველა თემა",
    final: "საბოლოო ცხრილი",
    accuracy: "{a}/{b} სწორი",
  },
  bluffSettings: {
    length: "თამაშის ხანგრძლივობა",
    short: "მოკლე (5)",
    normal: "ჩვეულებრივი (8)",
    long: "გრძელი (11)",
    speed: "ტაიმერი",
    chill: "მშვიდი",
    normalSpeed: "ნორმალური",
    fast: "სწრაფი",
    cats: "კატეგორიები",
    allCats: "ყველა კატეგორია",
    houseLie: "ჩვენი ტყუილიც იყოს",
    help: "„მომიფიქრე ტყუილი“ — რამდენჯერ",
    jokes: "წამყვანის ხუმრობები",
  },
  joker: {
    title: "ჯოკერის რვეული",
    sub: "დააჭირე, ვინ რას იძახის და რამდენი წაიღო — ქულებს, ხიშტს და პრემიებს რვეული თვითონ დათვლის. რეფრეშზე არაფერი იკარგება.",
    newGame: "ახალი თამაში",
    continue: "გაგრძელება",
    saved: "შენახული თამაშები",
    noSaved: "ჯერ არცერთი თამაში. დაიწყე ახალი!",
    deleteGame: "წაშლა",
    deleteConfirm: "წავშალოთ ეს თამაში სამუდამოდ?",
    players: "მოთამაშეები",
    playerPh: "მოთამაშე {n}",
    type: "თამაშის სახეობა",
    typeStandard: "სტანდარტული (1–8, 9×4, 8–1, 9×4)",
    typeNines: "ცხრიანები (9×16)",
    khishti: "ხიშტი",
    khishtiNone: "არ ვთამაშობთ",
    khishtiHint: "ჯარიმა, თუ თქვი 1 ან მეტი და ვერცერთი წაიღე",
    premium: "პრემია პულკის ბოლოს",
    premiumOn: "საუკეთესო ქულა ორმაგდება",
    premiumErase: "სხვებს ეშლებათ საუკეთესო ქულა",
    firstDealer: "პირველი დამრიგებელი",
    start: "რვეულის გახსნა",
    pulka: "პულკა {n}",
    deal: "დარიგება {n}",
    cards: "{n} კარტი",
    dealer: "არიგებს: {name}",
    stepBids: "ვინ რამდენს იძახის?",
    stepTaken: "ვინ რამდენი წაიღო?",
    bidOf: "{name} იძახის",
    takenOf: "{name}-მა წაიღო",
    pass: "პასი",
    forbidden: "{name}-ს არ შეუძლია თქვას {n} — ჯამი {cards} გამოვა",
    sumBids: "ნათქვამი ჯამში: {a} / {b}",
    sumTaken: "წაღებული ჯამში: {a} / {b}",
    takenMismatch: "წაღებული უნდა იყოს ზუსტად {n}",
    saveDeal: "ჩაწერა",
    editDeal: "რედაქტირება",
    editTitle: "დარიგების შესწორება",
    deleteDeal: "ბოლო დარიგების წაშლა",
    undo: "დაბრუნება",
    total: "ჯამი",
    premiumBadge: "პრემია",
    khishtiBadge: "ხიშტი",
    exact: "ზუსტად",
    finished: "თამაში დასრულდა!",
    rename: "სახელის შეცვლა",
    reset: "თავიდან დაწყება",
    resetConfirm: "ყველა დარიგება წაიშლება. დარწმუნებული ხარ?",
    rules: "წესები და ქულები",
    rulesList: [
      "ზუსტად თუ წაიღე, რამდენიც თქვი: 50 × ნათქვამი + 50 (პასი = 50).",
      "თუ ყველა კარტი თქვი და ყველა წაიღე: 100 × კარტების რაოდენობა.",
      "თუ ვერ შეასრულე: 10 × წაღებული.",
      "ხიშტი: თუ თქვი 1 ან მეტი და ვერცერთი წაიღე.",
      "დამრიგებელი (ბოლოს მთქმელი) ვერ იტყვის ისეთ რიცხვს, რომ ჯამი კარტების რაოდენობას გაუტოლდეს.",
      "პრემია: თუ პულკის ყველა დარიგება ზუსტად შეასრულე, პულკის საუკეთესო ქულა ორმაგდება.",
    ],
    sync: "სინქრონიზებულია ანგარიშთან",
    localOnly: "ინახება ამ მოწყობილობაზე. შედი ანგარიშზე, რომ სხვა მოწყობილობაზეც გქონდეს.",
    shareImage: "სურათად შენახვა",
    leader: "ლიდერობს: {name}",
  },
  auth: {
    loginTitle: "შესვლა",
    registerTitle: "რეგისტრაცია",
    withPassword: "პაროლით",
    withSms: "SMS კოდით",
    withEmail: "მეილის კოდით",
    identifier: "მომხმარებელი, მეილი ან ტელეფონი",
    username: "მომხმარებლის სახელი",
    usernameHint: "ლათინური ასოები, ციფრები, _ ან . (3–20)",
    email: "ელ-ფოსტა",
    phone: "ტელეფონის ნომერი",
    country: "ქვეყანა",
    password: "პაროლი",
    passwordHint: "მინიმუმ 8 სიმბოლო",
    displayName: "სახელი თამაშში (არასავალდებულო)",
    terms: "ვეთანხმები წესებს და ვადასტურებ, რომ 13 წელზე მეტის ვარ",
    login: "შესვლა",
    register: "რეგისტრაცია",
    noAccount: "ჯერ არ გაქვს ანგარიში?",
    haveAccount: "უკვე გაქვს ანგარიში?",
    forgot: "დაგავიწყდა პაროლი?",
    sendCode: "კოდის გაგზავნა",
    codeSent: "კოდი გაიგზავნა: {to}",
    code: "6-ნიშნა კოდი",
    verify: "დადასტურება",
    resend: "ხელახლა გაგზავნა",
    resendIn: "ხელახლა გაგზავნა {n} წამში",
    devCode: "სატესტო რეჟიმი: SMS/მეილის პროვაიდერი ჯერ არ არის მიერთებული. კოდია {code}",
    newPassword: "ახალი პაროლი",
    resetTitle: "პაროლის აღდგენა",
    resetDone: "პაროლი შეიცვალა — შენ უკვე შესული ხარ.",
    logout: "გასვლა",
    guestNote: "თამაში რეგისტრაციის გარეშეც შეიძლება. ანგარიში ინახავს შენს სტატისტიკას და ჯოკერის რვეულებს.",
    profile: "პროფილი",
    verifyPhone: "ტელეფონის დადასტურება",
    verifyEmail: "მეილის დადასტურება",
    verified: "დადასტურებულია",
    notVerified: "დაუდასტურებელი",
    adultToggle: "18+ კონტენტის ნახვა",
    adultConfirm: "ვადასტურებ, რომ 18 წლის ან მეტის ვარ",
    stats: "სტატისტიკა",
    played: "ნათამაშები",
    won: "მოგებული",
    best: "რეკორდი",
    changePassword: "პაროლის შეცვლა",
    currentPassword: "მიმდინარე პაროლი",
    saved: "შენახულია!",
    errors: {
      username_invalid: "მომხმარებლის სახელი არასწორია",
      username_taken: "ეს სახელი დაკავებულია",
      email_invalid: "მეილი არასწორია",
      email_taken: "ეს მეილი უკვე რეგისტრირებულია",
      phone_invalid: "ნომერი არასწორია",
      phone_taken: "ეს ნომერი უკვე რეგისტრირებულია",
      password_short: "პაროლი მინიმუმ 8 სიმბოლო უნდა იყოს",
      password_long: "პაროლი ძალიან გრძელია",
      password_digits: "პაროლი მხოლოდ ციფრებისგან არ უნდა შედგებოდეს",
      terms_required: "დაეთანხმე წესებს",
      bad_credentials: "მომხმარებელი ან პაროლი არასწორია",
      otp_invalid: "კოდი არასწორია",
      otp_expired: "კოდს ვადა გაუვიდა — მოითხოვე ახალი",
      otp_locked: "ძალიან ბევრი მცდელობა — მოითხოვე ახალი კოდი",
      delivery_failed: "კოდის გაგზავნა ვერ მოხერხდა. სცადე მოგვიანებით.",
      rate_limited: "ძალიან ხშირად ცდილობ. მოიცადე ცოტა ხანს.",
      auth_required: "ჯერ შედი ანგარიშზე",
      age_confirm_required: "დაადასტურე ასაკი",
      conflict: "ასეთი ანგარიში უკვე არსებობს",
      generic: "რაღაც არ გამოვიდა. სცადე ხელახლა.",
    },
  },
  err: {
    not_found: "ვერ მოიძებნა",
    not_host: "ეს მხოლოდ ჰოსტს შეუძლია",
    not_player: "შენ ამ რაუნდში არ თამაშობ",
    bad_phase: "ახლა ეს შეუძლებელია",
    bad_input: "რაღაც არასწორადაა შეყვანილი",
    too_few_players: "მოთამაშეები არ გყოფნით",
    room_full: "ოთახი სავსეა",
    name_taken: "ეს სახელი დაკავებულია",
    kicked: "ოთახიდან გაგაგდეს",
    rate_limited: "ცოტა ნელა 🙂",
    is_truth: "ეს სიმართლეა!",
    too_close: "ძალიან ჰგავს სიმართლეს",
    taken: "ეს უკვე დაწერეს",
    own_option: "საკუთარს ვერ აირჩევ",
    already: "უკვე გააკეთე",
    not_your_turn: "ახლა შენი ჯერი არ არის",
    no_help_left: "დახმარება აღარ დაგრჩა",
    self_vote: "საკუთარ თავს ვერ დაადანაშაულებ 😄",
    no_content: "ამ პარამეტრებით კითხვები არ მოიძებნა",
    paused: "თამაში პაუზაზეა",
    avatar_taken: "ეს ავატარი უკვე სხვას აქვს — აირჩიე სხვა",
    server: "სერვერის შეცდომა",
    name_required: "ჩაწერე სახელი",
    network: "კავშირის პრობლემა",
    csrf: "უსაფრთხოების შეცდომა — განაახლე გვერდი",
  },
  /** Bluffmania host lines (read by the narrator; 2–3 variants each, picked at random). */
  host: {
    welcome: [
      "მოგესალმებით ბლეფმანიაში! აქ სიმართლე უცნაურია, ტყუილი კი — თქვენი იარაღი.",
      "აბა, ჩემო ტყუილების ოსტატებო, დავიწყოთ!",
      "კეთილი იყოს თქვენი მობრძანება! დღეს ვნახავთ, ვინ იტყუება ყველაზე ლამაზად.",
    ],
    act0: ["პირველი რაუნდი! აბა, გავხურდეთ!", "იწყება პირველი რაუნდი. ტყუილები მოამზადეთ!"],
    act1: ["მეორე რაუნდი! ახლა ქულები ორმაგდება.", "ყურადღება: მეორე რაუნდში ყოველი ტყუილი ორჯერ მეტი ღირს!"],
    act2: ["ცხელი ფინალი! ერთი კითხვა, სამმაგი ქულები. ყველაფერი ახლა წყდება!", "ფინალი! აქ ლიდერიც კი შეიძლება ჩამოვარდეს."],
    write: ["მოიფიქრეთ ტყუილი!", "ახლა ტყუილის დროა."],
    hurry: ["ათი წამი დარჩა!", "ჩქარა, დრო იწურება!"],
    timeup: ["დრო ამოიწურა!", "კალმები ძირს!"],
    vote: ["ახლა იპოვეთ სიმართლე!", "ერთ-ერთი პასუხი მართალია. რომელი?", "აირჩიეთ სიმართლე და ნუ წამოეგებით!"],
    lie: ["ეს ტყუილი იყო!", "ტყუილია!", "ოჰო, ეს მოგონილი იყო!"],
    fooledMany: ["ამდენი ხალხი წამოეგო!", "ბრავო, მატყუარავ!", "ოსკარი ამ ტყუილს!"],
    truth: ["და სიმართლე არის…", "ახლა კი — სიმართლე!", "მართალი პასუხი კი ასეთია…"],
    nobody: ["სიმართლე ვერავინ იპოვა!", "ვაი, ყველა წამოეგო!"],
    everyone: ["ყველამ იპოვა სიმართლე! ძალიან ჭკვიანი ხალხი ყოფილხართ.", "ყველამ გამოიცნო — შემდეგ ჯერზე უკეთ იტყუეთ!"],
    scores: ["ვნახოთ ცხრილი!", "აბა, ვინ ლიდერობს?"],
    winner: ["და ჩვენი გამარჯვებულია…", "ტყუილების მეფე ვინ გახდა? აი, ის!"],
    outro: ["მადლობა თამაშისთვის! მალე შევხვდეთ.", "კარგი თამაში იყო! კიდევ ერთხელ?"],
    /** "Question two!" … (index = question number − 1) */
    qnum: ["პირველი კითხვა!", "მეორე კითხვა!", "მესამე კითხვა!", "მეოთხე კითხვა!", "მეხუთე კითხვა!", "მეექვსე კითხვა!", "მეშვიდე კითხვა!", "მერვე კითხვა!", "მეცხრე კითხვა!", "მეათე კითხვა!"],
    /** said instead of the plain "write" line on 2–3 questions per game (can be switched off) */
    joke: [
      "აბა, დაწერეთ ისეთი ტყუილი, დედამთილმაც რომ დაიჯეროს!",
      "თუ ოდესმე გითქვამთ „გზაში ვარ“, როცა ჯერ საწოლიდანაც არ ამდგარხართ — მზად ხართ!",
      "„მარშრუტკა არ მოვიდა“ — თბილისის კლასიკა. ახლა თქვენი ვერსია!",
      "„ხუთ წუთში მანდ ვარ!“ — აი, ასეთი დამაჯერებლობა გვჭირდება.",
      "დაწერეთ ისე დამაჯერებლად, როგორც „ხვალიდან დიეტაზე ვარ“.",
      "„ბოლო ჭიქაა“ — სუფრის მთავარი ტყუილი. ახლა თქვენ სცადეთ!",
      "ტყუილი ხაჭაპურივით უნდა იყოს: ცხელი, მრგვალი და ძალიან დამაჯერებელი!",
      "„ტელეფონი ხმაზე არ მქონდა“ — ძველი ხერხია. მოიფიქრეთ ახალი!",
      "გახსოვთ, „ძაღლმა შემიჭამა დავალება“? აი, ის ნიჭი დაბრუნდა!",
      "დაწერეთ ისეთი ტყუილი, რომ ხვალ თქვენც დაიჯეროთ!",
      "წარმოიდგინეთ, რომ ამინდის პროგნოზს წერთ: თამამად და სრულიად მოგონილად!",
      "იტყუეთ ისე, როგორც რეზიუმეში: „თავისუფლად ვფლობ ინგლისურს“.",
      "იტყუეთ ისე ლამაზად, როგორც გაცნობის აპლიკაციის ფოტო!",
      "„ერთი წუთით შემოვიარე“ — და დილამდე დარჩა. ასეთივე ტყუილი გვინდა!",
      "„ცოტას შევჭამ, მშიერი არ ვარ“ — და მესამე თეფში. აი, ეს არის ოსტატობა!",
      "დაწერეთ ისეთი ტყუილი, რომ თამადამ მისი სადღეგრძელო შესვას!",
      "იტყუეთ ისე, როგორც ბავშვობაში: „მე არ ვყოფილვარ!“",
      "მოიფიქრეთ ტყუილი, ექიმის ხელწერაზე უფრო ძნელად გასარჩევი!",
      "იტყუეთ, როგორც გამყიდველი: „ეს ფერი ძალიან გიხდებათ!“",
      "„ფასდაკლებით ვიყიდე“ — ოჯახური ტყუილების ჩემპიონი. თქვენი რიგია!",
      "ტყუილი ჩაწერეთ, სანამ სინდისი დაგეწევათ!",
      "დაწერეთ ისეთი ტყუილი, რომ ვიკიპედიამაც შეიტანოს!",
      "ჩართეთ ის ნიჭი, ბოლო გამოცდაზე რომ გადაგარჩინათ!",
      "იტყუეთ, როგორც მეგობარი: „არა, საერთოდ არ ვბრაზობ“.",
      "„ხვალ აუცილებლად დაგირეკავ“ — დაწერეთ ასეთივე თბილი ტყუილი!",
      "იტყუეთ, როგორც ავტოხელოსანი: „ერთი პატარა დეტალია შესაცვლელი“.",
      "„ახლავე ვჯდები სამეცადინოდ“ — სტუდენტების ჰიმნი. ახლა თქვენ!",
      "„პირობას გაძლევ, უკანასკნელად იყო“ — დაწერეთ ასეთივე გულწრფელი ტყუილი!",
      "მოიფიქრეთ ჩემზე უკეთესი ტყუილი. ჩემი ხომ იცით: „ეს კითხვა მარტივია!“",
      "იტყუეთ თავდაჯერებულად, როგორც მძღოლი, რომელიც „გზას ზეპირად იცნობს“ და ნავიგატორს არ რთავს.",
      "„ერთი სერია და დავიძინებ“ — დილის სამი საათია. ახლა თქვენ დაწერეთ!",
      "„არა, მართლა აღარ მინდა“, — ამბობს სტუმარი და მეოთხე ხინკალს იღებს. აბა, თქვენ!",
      "„ბატარეა დამიჯდა“ — ყველაზე ძველი ტყუილია. მოიფიქრეთ ახალი!",
      "ტყუილის დროა! დედას არაფერს ვეტყვით.",
      "წერეთ თამამად! ზოგს ტყუილისთვის ოსკარს აძლევენ, თქვენ — ქულებს.",
      "დაწერეთ ისეთი ტყუილი, ბებიის რეცეპტივით რომ გადაეცეს თაობებს!",
      "მოიფიქრეთ ისეთი, რომ ჩემმა ხელოვნურმა ინტელექტმაც ვერ გაარჩიოს!",
      "სრულყოფილ ტყუილს ცოტა სიმართლე სჭირდება, როგორც ჭაჭას — ცოტა ყურძენი!",
      "„უკვე ვჭამე“, — ეუბნებით დედას. ახლა იგივე ნიჭი აქ გამოიყენეთ!",
      "„ჩემი ბრალი არ არის, ინტერნეტი გაითიშა“ — ასე მარტივად და დამაჯერებლად!",
      "დაწერეთ ისე, როგორც ტაქსისტი: „აქედან ყველაზე მოკლე გზაა!“",
      "იტყუეთ ისე უდანაშაულოდ, როგორც ბავშვი, შოკოლადით მოსვრილი პირით.",
      "ტყუილი ქართულ ცეკვასავით უნდა იყოს: ლამაზი, სწრაფი და შთამბეჭდავი!",
      "„ხვალიდან ადრე ავდგები“ — ყოველ საღამოს ნათქვამი. ახლა რამე ახალი!",
      "„წავიკითხე წესები და პირობები“ — მსოფლიოში ყველაზე დიდი ტყუილი. აბა, აჯობეთ!",
      "„ჩემი წილი უკვე გადავიხადე“ — სუფრის კლასიკა. თქვენი ჯერია!",
      "ისეთი ტყუილი დაწერეთ, რომ სიმართლესაც შეშურდეს!",
      "„თითქმის მზად ვარ“ — ამბობს ყველა, ვინც ჯერ არც ჩაცმულა. აი, ასე!",
      "იტყუეთ ისე მშვიდად, როგორც კატა, რომელმაც ახლახან ვაზა გადააგდო.",
      "დაწერეთ ტყუილი, რომელსაც ბებიაჩემიც კი ვერ ამოიცნობდა!",
    ],
    /** the first question of a replay */
    welcomeBack: ["ვაა, ისევ აქ ხართ? ესე იგი მოგეწონათ! მადლობა, რომ დაბრუნდით!", "კიდევ ერთი თამაში? ასე მიყვარს! ახლა კიდევ უფრო ლამაზად ვიტყუოთ.", "მადლობა, რომ კვლავ გვეწვიეთ! ვიცოდი, ერთი თამაში არ გეყოფოდათ."],
    prevWinner: ["წინა თამაშის ჩემპიონო, შენი გვირგვინი საფრთხეშია!", "წინა გამარჯვებულს ვაფრთხილებთ: დღეს გვირგვინს ჩამოგართმევენ!"],
    prevLoser: ["წინა თამაშში ვიღაცას არ გაუმართლა — მოდით, მხურვალედ გავამხნევოთ! დღეს მისი დღეა!", "ბოლო ადგილზე მყოფო, ნუ ნაღვლობ: დღეს შენი რევანშის დღეა!"],
    /** said right after the player's name (Georgian: the name in the dative, "მარიამს, …") */
    prevWinnerName: ["წინა თამაშში ყველაზე კარგად გამოუვიდა ტყუილი. გვირგვინი საფრთხეშია!", "ჯერ კიდევ ჩემპიონის გვირგვინი ახურავს. ვინ ჩამოართმევს?"],
    prevLoserName: ["წინა თამაშში არ გაუმართლა — მოდით, მხურვალედ გავამხნევოთ!", "წინა თამაშში იღბალი არ ჰქონდა. დღეს მისი რევანშის დღეა!"],
  },
  shouts: {
    fooledAll: ["ყველა წამოეგო! 🔥", "რა ტყუილია, ბიჭო!", "ოსკარი ამას!"],
    truthFound: ["დეტექტივი!", "ვერაფერს გამოაპარებ!", "ცხვირი ცხვირში აქვს!"],
    nobody: ["სიმართლე ვერავინ იპოვა 😱", "ეს ფაქტი თვითონ არ გჯერა, ხომ?"],
    hot: ["ცხელა! 🔥", "გაცხელდა!", "ვაი, ვაი!"],
    spyCaught: ["გამოიჭირეს!", "აღარ გიშველის სათვალე!"],
    spyFree: ["ჯაშუში გაიპარა!", "ჯეიმს ბონდი გვყავდა 😎"],
  },
  brand: {
    title: "ბრენდბუქი",
  },
  avatars: {
    khinkali: "ხინკალი",
    churchkhela: "ჩურჩხელა",
    pomegranate: "ბროწეული",
    grapes: "საფერავი",
    khachapuri: "ხაჭაპური",
    pepper: "წიწაკა",
    kantsi: "ყანწი",
    dog: "ნაგაზი",
    cat: "კატა",
    bear: "დათვი",
    fox: "მელა",
    owl: "ბუ",
    sheep: "ცხვარი",
    tur: "ჯიხვი",
    tamada: "თამადა",
    spy: "აგენტი",
    car: "მანქანა",
    rooster: "მამალი",
    cow: "ძროხა",
  },
  prefs: {
    title: "პარამეტრები",
    sound: "ხმოვანი ეფექტები",
    narrator: "წამყვანის ხმა",
    narratorHint: "წამყვანი ხმამაღლა კითხულობს კითხვებს. ერთ ოთახში ჩართე მხოლოდ ერთ მოწყობილობაზე — ჰოსტის ტელეფონზე ან ტელევიზორზე.",
    haptics: "ვიბრაცია",
    volume: "ხმის სიმაღლე",
    language: "საიტის ენა",
  },
  local: {
    playersTitle: "ვინ თამაშობს?",
    addPlayer: "+ მოთამაშე",
    addBot: "+ ბოტი",
    playerPh: "მოთამაშე {n}",
    min: "საჭიროა მინიმუმ {n} მოთამაშე",
    start: "დავიწყოთ!",
    passTo: "გადაეცი ტელეფონი",
    tapWhenReady: "როცა მზად იქნები, შეეხე",
    hideAndPass: "დამალე და გადაეცი შემდეგს",
    remove: "წაშლა",
    resumeTitle: "გაგრძელება?",
    resumeText: "ამ მოწყობილობაზე დაუსრულებელი თამაშია.",
    resume: "გაგრძელება",
    discard: "ახლიდან",
  },
  demo: {
    note: "ეს წინასწარი ვერსიაა: თამაშები ბრაუზერში მუშაობს ბოტებით და ერთ ტელეფონზე. ონლაინ ოთახები, რეგისტრაცია და SMS სერვერზე გაშვების შემდეგ ჩაირთვება.",
    serverOnly: "ეს ფუნქცია სერვერზე გაშვების შემდეგ იმუშავებს.",
    playBots: "ბოტებთან თამაში",
  },
  notFound: {
    title: "ეს გვერდი ვერ ვიპოვეთ",
    sub: "როგორც ჩანს, ვიღაცამ გაბლეფა 😏",
    home: "მთავარზე",
  },
};

export type Dict = typeof ka;
export default ka;
